import angular from 'angular';

(function() {
  'use strict';

  angular.module('app.prepasrel').config(routesConfig);

  routesConfig.$inject = ['$stateProvider'];

  /* @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('app.prepasrel', {
        abstract: true,
        component: 'contentLayout',
        data: {
          authorizedRole: 'USER_BO'
        }
      })
      .state('app.prepasrel.list-workflows', {
        url: '/prepasrel/list-workflows',
        views: {
          content: {
            component: 'listWorkflows'
          }
        }
      })
      .state('app.prepasrel.edit-workflow', {
        url: '/prepasrel/workflow/{name}',
        views: {
          content: {
            templateUrl: require('./edit-workflow.html'),
            controller: 'EditWorkflowCtrl',
            controllerAs: 'vm'
          }
        },
        resolve: {
          workflow: getWorkflow
        }
      })
      .state('app.prepasrel.new-workflow', {
        url: '/prepasrel/workflow/new',
        views: {
          content: {
            templateUrl: require('./edit-workflow.html'),
            controller: 'EditWorkflowCtrl',
            controllerAs: 'vm'
          }
        },
        resolve: {
          workflow: [
            'PrePasrelWorkflow',
            function(PrePasrelWorkflow) {
              return new PrePasrelWorkflow();
            }
          ]
        }
      });
  }

  getWorkflow.$inject = ['$transition$', '$state', 'logger', 'PrePasrelSvc'];

  function getWorkflow($transition$, $state, logger, PrePasrelSvc) {
    return PrePasrelSvc.getWorkflow($transition$.params().name).then(
      function(workflow) {
        return workflow;
      },
      function(error) {
        if (error.status === 404) {
          logger.error('prepasrel.workflow.status.error_notfound', $transition$.params().name);
          $state.go('app.prepasrel.list-workflows');
        }
      }
    );
  }
})();
